import { useTransform } from "framer-motion";

// Maps the section's 0..1 scroll progress to a stage's opacity/translate window.
export function useStageMotion(progress, index, total, fade = 0.06, travel = 0) {
  const s = index / total;
  const e = (index + 1) / total;
  const first = index === 0;
  const last = index === total - 1;

  const opIn = first ? [e, e + fade] : last ? [s - fade, s] : [s - fade, s, e, e + fade];
  const opOut = first ? [1, 0] : last ? [0, 1] : [0, 1, 1, 0];
  const opacity = useTransform(progress, opIn, opOut);
  const y = useTransform(progress, [first ? 0 : s, last ? 1 : e], [first ? 0 : travel, last ? 0 : -travel]);

  return { opacity, y };
}
